import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, ExternalLink } from "lucide-react";
import { api } from "../../lib/api";
import { AccountPicker } from "./Customer360";

const when = (iso) => { try { return new Date(iso).toLocaleString("es-MX", { dateStyle: "medium", timeStyle: "short" }); } catch { return ""; } };

export default function CustomerTimeline() {
  const [cuenta, setCuenta] = useState("");
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!cuenta) { setEvents([]); return; }
    setLoading(true);
    api.get(`/mod/cx/timeline`, { params: { cuenta } }).then((r) => setEvents(r.data.events || [])).catch(() => {}).finally(() => setLoading(false));
  }, [cuenta]);

  return (
    <div className="space-y-4" data-testid="module-timeline">
      <AccountPicker value={cuenta} onChange={setCuenta} testid="timeline-account" />
      {loading && <div className="py-8 flex justify-center text-navy/40"><Loader2 className="w-5 h-5 animate-spin" /></div>}
      {!loading && cuenta && events.length === 0 && <div className="card-surface py-10 text-center text-navy/40 text-sm">Sin interacciones registradas para este cliente todavía.</div>}
      {!loading && events.length > 0 && (
        <div className="relative pl-5 border-l-2 border-navy/10 space-y-4">
          {events.map((e, i) => (
            <div key={i} className="relative" data-testid={`timeline-event-${i}`}>
              <span className="absolute -left-[26px] top-1.5 w-3 h-3 rounded-full bg-violet border-2 border-cream" />
              <div className="flex items-center gap-2">
                <span className="text-[10px] uppercase tracking-wide text-violet bg-violet/10 rounded px-2 py-0.5">{e.type}</span>
                <span className="text-[11px] text-navy/40">{when(e.at)}</span>
              </div>
              <Link to={`/os/mod/${e.module_key}`} className="mt-1 flex items-center gap-1.5 text-sm text-navy/80 hover:text-violet w-fit">
                {e.label} <ExternalLink className="w-3 h-3 text-navy/25" />
              </Link>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
